import { Box } from '@mui/material';

import type { ReactNode } from 'react';

interface ReportDrillInLayoutProps {
    children: ReactNode;
}

export const ReportDrillInMetrics = ({
    children,
}: ReportDrillInLayoutProps) => (
    <Box
        sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '16px',
            marginBottom: '24px',
        }}
    >
        {children}
    </Box>
);

export const ReportDrillInSections = ({
    children,
}: ReportDrillInLayoutProps) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '32px',
        }}
    >
        {children}
    </Box>
);
